<template>
	<div class="margin-left">
		<div class="bg-white methoditem flex flex-direction">
			<p class="text-df bgth text-theme text-left padding-left">方法一</p>
			<div class="flex flex-direction justify-center flex-sub padding-left">
				<p class="text-left text-666 text-sm">请好友打开微情，扫描下方二维码，授权置录即可</p>
				<img class="ercode margin-top-sm" :src="QrCode">
			</div>
		</div>
		<div class="bg-white methoditem margin-top-sm  flex flex-direction">
			<p class="text-df bgth text-theme text-left padding-left">方法二</p>
			<div class="flex flex-direction justify-between padding-tb flex-sub padding-left">
				<p class="text-left text-666 text-sm">点击下方“专属邀请链接”，复制粘贴到微信群工友点击您分享的链接，授权登录即可 </p>
				<p class="copybtn text-theme margin-top pointer" @click="copy">专属邀请链接</p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				url: '', //分享的链接
				QrCode: ''
			}
		},
		created() {
			this.url = `https://ciiply.com/h5/#/?grains=${localStorage.getItem('user_token')}`
			this.getQrCode()
		},
		methods: {
			/**
			 * 获取分销二维码
			 * */
			getQrCode() {
				this.ajax('get', '/api/system/getQrCode', {}, res => {
					console.log(res);
					if (res.status == 200) {
						this.QrCode = res.data.url
					} else {

					}
				})
			},
			copy() {
				this.$alert(this.url, '专属邀请链接', {
					confirmButtonText: '确定',
					callback: action => {

					}
				});
			}
		}
	}
</script>

<style scoped lang="less">
	.methoditem {
		width: 918px;
		height: 245px;
		border-radius: 16px;

		.bgth {
			background-color: #F1F8F8;
			height: 41px;
			line-height: 41px;
			border-radius: 16px 16px 0 0;
		}

		.ercode {
			width: 98px;
			height: 98px;
		}

		.copybtn {
			width: 231px;
			height: 44px;
			line-height: 44px;
			background: #FFFFFF;
			border: 1px solid #0B837C;
			border-radius: 22px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/my/task/share.vue